module.exports = "pegasus_template/assets/frame-twitter-old.png";